export const INIT = 'KARTA_PRZEDMIOTU/INIT';

export const GET_LEFT_PANEL_DATA_START = 'KARTA_PRZEDMIOTU/GET_LEFT_PANEL_DATA_START';
export const FETCH_CARD_DATA_START = 'KARTA_PRZEDMIOTU/FETCH_CARD_DATA_START';
export const FETCH_CARD_DATA_FAIL = 'KARTA_PRZEDMIOTU/FETCH_CARD_DATA_FAIL';

export const FORM_TEMPLATE_GET_START = 'KARTA_PRZEDMIOTU/FORM_TEMPLATE_GET_START';
export const FORM_TEMPLATE_GET_SUCCESS = 'KARTA_PRZEDMIOTU/FORM_TEMPLATE_GET_SUCCESS';
export const FORM_TEMPLATE_GET_FAIL = 'KARTA_PRZEDMIOTU/FORM_TEMPLATE_GET_FAIL';

export const FORM_TEMPLATE_SET_VERSION = 'KARTA_PRZEDMIOTU/FORM_TEMPLATE_SET_VERSION';
export const FORM_UPDATE_EDIT_MODE_STATUS = 'KARTA_PRZEDMIOTU/FORM_UPDATE_EDIT_MODE_STATUS';
export const FORM_TOGGLE_EDIT_MODE = 'KARTA_PRZEDMIOTU/FORM_TOGGLE_EDIT_MODE';
export const FORM_RESET_DATA = 'KARTA_PRZEDMIOTU/FORM_RESET_DATA';

export const FORM_DATA_GET_START = 'KARTA_PRZEDMIOTU/FORM_DATA_GET_START';
export const FORM_DATA_GET_SUCCESS = 'KARTA_PRZEDMIOTU/FORM_DATA_GET_SUCCESS';
export const FORM_DATA_GET_FAIL = 'KARTA_PRZEDMIOTU/FORM_DATA_GET_FAIL';

export const FORM_DATA_SAVE_START = 'KARTA_PRZEDMIOTU/FORM_DATA_SAVE_START';
export const FORM_DATA_SAVE_SUCCESS = 'KARTA_PRZEDMIOTU/FORM_DATA_SAVE_SUCCESS';
export const FORM_DATA_SAVE_FAIL = 'KARTA_PRZEDMIOTU/FORM_DATA_SAVE_FAIL';

export const FORM_DATA_UPDATE = 'KARTA_PRZEDMIOTU/FORM_DATA_UPDATE';

export const KARTA_SAVE_TEMPORARILY_IN_SID_START = 'KARTA_PRZEDMIOTU/KARTA_SAVE_TEMPORARILY_IN_SID_START';
export const KARTA_SAVE_TEMPORARILY_IN_SID_SUCCESS = 'KARTA_PRZEDMIOTU/KARTA_SAVE_TEMPORARILY_IN_SID_SUCCESS';
export const KARTA_SAVE_TEMPORARILY_IN_SID_FAIL = 'KARTA_PRZEDMIOTU/KARTA_SAVE_TEMPORARILY_IN_SID_FAIL';

export const INIT_PUBLISHING = 'KARTA_PRZEDMIOTU/INIT_PUBLISHING';

export const KARTA_PUBLISH_IN_SID_START = 'KARTA_PRZEDMIOTU/KARTA_PUBLISH_IN_SID_START';
export const KARTA_PUBLISH_IN_SID_SUCCESS = 'KARTA_PRZEDMIOTU/KARTA_PUBLISH_IN_SID_SUCCESS';
export const KARTA_PUBLISH_IN_SID_FAIL = 'KARTA_PRZEDMIOTU/KARTA_PUBLISH_IN_SID_FAIL';

export const LEARNING_EFFECTS_PUBLISH_IN_SID_START = 'KARTA_PRZEDMIOTU/LEARNING_EFFECTS_PUBLISH_IN_SID_START';
export const LEARNING_EFFECTS_PUBLISH_IN_SID_SUCCESS = 'KARTA_PRZEDMIOTU/LEARNING_EFFECTS_PUBLISH_IN_SID_SUCCESS';
export const LEARNING_EFFECTS_PUBLISH_IN_SID_FAIL = 'KARTA_PRZEDMIOTU/LEARNING_EFFECTS_PUBLISH_IN_SID_FAIL';

export const GET_CARD_FROM_SID_START = 'KARTA_PRZEDMIOTU/GET_CARD_FROM_SID_START';
export const GET_CARD_FROM_SID_SUCCESS = 'KARTA_PRZEDMIOTU/GET_CARD_FROM_SID_SUCCESS';
export const GET_CARD_FROM_SID_FAIL = 'KARTA_PRZEDMIOTU/GET_CARD_FROM_SID_FAIL';
